import { combineReducers } from "redux";
import authReducer from "./auth";
import dashboardReducer from "./dashboard";
import notifyReducer from "./notifications";
import rateReducer from "./rate";
import tradeReducer from "./trade";
import walletReducer from "./wallets";


const appReducer = combineReducers({
  auth: authReducer,
  trade: tradeReducer,
  wallet: walletReducer,
  notification: notifyReducer,
  rate: rateReducer,
  dashboard: dashboardReducer
});

const rootReducer = (state, action) => {
  if (action.type === "logout") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
  